import gettext from '@sdk/lang/gettext';
import { BreakViolation } from '@sdk/automatedBreaks/types/BreakViolation';
import { AutomatedBreakType } from '@sdk/settings/types';
import { AttestationOption } from '@sdk/automatedBreaks/types/Attestation';

import breakViolationToText from '@web/timeClock/utils/breakViolationToText';

type BreakObject = {
  violations: BreakViolation[];
  isMissed: boolean;
  isExcessive: boolean;
  breakType: AutomatedBreakType;
  attestationOption?: AttestationOption;
};

const getExcessiveMessage = (type: AutomatedBreakType) => {
  if (type === AutomatedBreakType.meal) {
    return gettext('Excessive meal break');
  }

  return gettext('Excessive rest break');
};

const stringifyBreakViolations = (breakObject: BreakObject) => {
  if (breakObject.isExcessive) {
    return getExcessiveMessage(breakObject.breakType);
  }

  if (
    breakObject.isMissed &&
    ![AttestationOption.waived, AttestationOption.taken].includes(breakObject.attestationOption)
  ) {
    return breakObject.breakType === AutomatedBreakType.meal
      ? gettext('Meal break was missed')
      : gettext('Rest break was missed');
  }

  if (!breakObject.violations?.length) {
    return '';
  }

  return breakObject.violations
    .map((violation) => breakViolationToText[violation](breakObject.breakType))
    .join('\n');
};

export default stringifyBreakViolations;
